var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAugentColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3378.69 522.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #2e013c;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -51.37,
    y1: 763.55,
    x2: 968.16,
    y2: -24.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#674220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#a77c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#d3b160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d5b462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#dbbd69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#e6ce76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f6e587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f8e88a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ae7936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#eabe69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8d5924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfa54d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M982.83,279.16v21.84c.34-11.43.23-17.41,0-21.84ZM450.77,407.31s-13.82-4.04-28.67-8.36c-23.6-6.88-42.09-24.91-49.12-47.98-4.41-14.48-8.56-27.98-8.56-27.98-.28-1-1.19-1.65-2.25-1.65s-1.93.65-2.25,1.65c0,0-4.12,13.51-8.53,27.98-7.05,23.06-25.51,41.1-49.12,47.98-14.85,4.32-28.67,8.36-28.67,8.36-.99.28-1.68,1.17-1.68,2.19s.68,1.91,1.68,2.19c0,0,13.82,4.04,28.67,8.36,23.61,6.85,42.06,24.91,49.12,47.98,4.41,14.48,8.53,27.98,8.53,27.98.31.97,1.22,1.65,2.25,1.65s1.96-.68,2.25-1.65c0,0,4.15-13.51,8.56-27.98,7.03-23.07,25.51-41.12,49.12-47.98,14.85-4.32,28.67-8.36,28.67-8.36,1-.28,1.68-1.19,1.68-2.19s-.68-1.91-1.68-2.19ZM944.12,154.02c-12.34-3.33-43.51-3.98-58.64-2.47-.26.03-.51.06-.77.09-10.3,1.22-18.26,9.95-18.29,20.59v.06l-.17,35.52-.51,114.02-.03,5.06v4.04c-.54,8.87-.37,25.57-3.7,32.9-5.86,12.97-13.45,22.95-23.32,25.45h-.03c-2.62.82-37.37.88-53.72,1.08l-70.39-.06c-1.73.03-3.44.03-5.18,0-32.85-.4-64.13-20.88-87.68-52.84l-6.74-10.58L418.75,20.35C400.01-1.83,368.95-1.23,344.75,1.1c-11.94,1.14-22.27,3.95-32.42,12.14-46.1,61.72-87.8,129.52-131.19,194.56C121.15,297.7,59.72,386.46,1.56,478.04c-5.8,22.21,5.15,40.53,23.35,42.49,21.67,2.33,62.65,2.3,84.33,0,7.79-.82,16.13-4.1,22.18-10.32l225.3-338.89c5.23-4.89,10.44-1.42,13.96,4.38,56.57,81.28,106.22,176.81,163.81,256.25,37.91,52.24,90.01,84.64,146.84,88.59,35.44,2.47,118,2.59,153.38,0,46.33-3.36,86.54-31.37,113.13-73.63,19.45-30.91,31.65-69.51,33.64-111.68.71-15.13,1.14-26.05,1.34-34.21v-87.8c-.85-27.9-16.44-53.21-38.71-59.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1593.36,250.4c-2.41-5.55-5.73-10.45-9.94-14.71-4.22-4.25-9.22-7.62-15-10.1-5.78-2.48-12.06-3.72-18.8-3.72h-296.86v92.86h250.22v115.54h-292.47c-12.06,0-21.39-3.24-28.02-9.75-6.63-6.5-9.94-15.65-9.94-27.47v-248.81c0-12.52,3.25-21.97,9.76-28.35,6.51-6.38,15.91-9.57,28.2-9.57h382.13v-35.27c0-.16-.02-.31-.02-.47V14.18h-382.11c-16.15,0-30.61,2.01-43.38,6.03-12.78,4.02-24.04,9.39-33.8,16.13-9.76,6.73-18.14,14.48-25.13,23.22-6.99,8.74-12.65,17.9-16.99,27.47-4.34,9.57-7.54,19.26-9.58,29.06-2.05,9.81-3.07,18.96-3.07,27.47v249.52c0,15.83,2.05,30.07,6.15,42.71,4.1,12.64,9.58,23.75,16.45,33.32,6.87,9.57,14.76,17.72,23.68,24.45,8.91,6.73,18.26,12.23,28.02,16.48,9.76,4.25,19.64,7.39,29.65,9.4,10,2.01,19.34,3.01,28.02,3.01h339.11c6.74,0,13.01-1.18,18.8-3.54,5.78-2.36,10.78-5.61,15-9.75,4.21-4.13,7.53-9.04,9.94-14.71,2.41-5.67,3.61-11.81,3.61-18.43v-207.7c0-6.38-1.21-12.34-3.61-17.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3305.43 14.18 3196.5 14.18 3093.99 14.18 2870.03 14.18 2870.03 14.18 2870.03 106.33 2943.29 106.33 3077.54 106.33 3077.54 341.25 3077.18 341.25 3077.18 522.43 3171.54 522.43 3171.54 341.25 3171.54 106.33 3196.5 106.33 3378.69 106.33 3378.69 106.33 3378.69 14.18 3305.43 14.18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2065.29,221.87h-241.21v92.86h296.81v-92.51h-50.01c-1.84-.23-3.71-.35-5.59-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2089.72,14.18h-349.87c-6.75,0-13.01,1.19-18.8,3.54-5.78,2.36-10.79,5.67-15,9.92-4.22,4.25-7.54,9.22-9.94,14.89-2.41,5.67-3.61,11.7-3.61,18.08v332.45c0,23.87,4.39,44.01,13.2,60.43,8.8,16.43,19.76,29.77,32.9,40.05,13.13,10.28,27.41,17.67,42.84,22.15,15.42,4.49,29.65,6.73,42.66,6.73h339.11v-92.15h-338.38c-12.53,0-22.05-3.19-28.56-9.57-6.51-6.38-9.76-15.6-9.76-27.65V106.33h376.7V14.18h-73.47Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2682.01,14.18v350.88L2338.57,13.82c-6.75-6.85-14.82-11.16-24.22-12.94-9.4-1.77-18.56-.89-27.47,2.66-8.44,3.78-15.37,9.52-20.79,17.19-5.42,7.68-8.13,16.25-8.13,25.7v325.9c0,7.15-.13,14.25-.13,21.39v63.96c0,18.02.13,36.09.13,54.13v10.61h94V157.36l343.44,351.59c4.58,4.73,9.82,8.15,15.73,10.28,5.9,2.13,11.75,3.19,17.53,3.19,6.51,0,12.65-1.19,18.44-3.55,5.79-2.36,10.78-5.61,15-9.75,4.21-4.13,7.59-9.04,10.12-14.71,2.53-5.67,3.8-11.81,3.8-18.43V14.18h-94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAugentColor);
export default __webpack_public_path__ + "static/media/AugentColor.6bf176996970a9aedc076e2c37753e6c.svg";
export { ForwardRef as ReactComponent };